var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodcastIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3655",
    "data-name": "Groupe 3655",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.451,
    height: 14.402,
    viewBox: "0 0 12.451 14.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 14.402,
    height: 2.668,
    rx: 1.334,
    transform: "translate(9.782 14.402) rotate(-90)",
    fill: "#3e3e3e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 11.153,
    height: 2.668,
    rx: 1.334,
    transform: "translate(4.823 12.778) rotate(-90)",
    fill: "#3e3e3e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 6.827,
    height: 2.668,
    rx: 1.334,
    transform: "translate(0 10.731) rotate(-90)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcastIconBlack);
export default __webpack_public_path__ + "static/media/podcastIconBlack.92b678d114767b78698d76295cb8e845.svg";
export { ForwardRef as ReactComponent };